// 设置文本 超出x个字符部分显示...
export function setTxtLength(txt: string, showLen: number = 8) {
  if (!txt) return
  if (txt.length > showLen) {
    return txt.slice(0, showLen) + '...'
  }
  return txt
}